<template>
    <button
        class="tw-border tw-text-left tw-p-4 tw-rounded-md tw-cursor-pointer hover:tw-ring-2 tw-transition-all"
        :class="[
            {
                'tw-bg-eventwise/10 tw-border-eventwise/75 tw-ring-2 tw-ring-eventwise/20': checked,
                'hover:tw-bg-slate-100/50 hover:tw-ring-slate-100': !checked,
            },
            checked ? checkedClass : '',
        ]"
    >
        <slot></slot>
    </button>
</template>
<script setup>
defineProps({
    checked: {
        type: Boolean,
        default: false,
    },
    checkedClass: {
        type: String,
        default: '',
    },
});
</script>
